angular.module('smartorg.r6.navs.navbar').directive("rangalNav", ['$timeout', function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/navbar.html'),
            transclude: true,
            scope: {
                portfolioData: "=",
                userName: "=",
                userEmail: "@",
                isAdmin: "@",
                versionLog: "=",
                onZendeskRedirect: "&",
                onSelectPortfolio: "&",
                calcEngineState: '=?',
                showLogout: '<?',
                zendeskToggle: '=',
                showTutorial: '<',
                calcEngineAccess: '<?',
                userPortfolioAccess: '<?',
            },
            link: function (scope) {
                scope.showCalcEngineStateBox = false;
                /**
                 * Highlight selected portfolio.
                 */
                scope.$on('manage:SelectedPortfolio', function (event, args) {
                    scope.selectTreeName = args.selectedPortfolio;
                });
                /**
                 * When select a portfolio.
                 *
                 * @param portfolio {{text: string}} Text is also the unique
                 *     key of portfolio. Also same as tree root id display.
                 */
                scope.portfolioClicked = function (portfolio) {
                    scope.selectTreeName = portfolio.text;
                    scope.onSelectPortfolio({ treeID: portfolio.text });
                };
                scope.isSOrgAdminUser = function () {
                    return scope.isAdmin == 'true' && scope.userEmail && scope.userEmail.endsWith('@smartorg.com');
                };
                scope.isAdminUser = function () {
                    return scope.isAdmin == 'true';
                };
                /**
                 * For administrative menu items.
                 *
                 * @param command {string}
                 */
                scope.triggerEmit = function (command) {
                    scope.$emit('workbench:emit', {
                        command: command
                    });
                };
                scope.logout = function () {
                    scope.$emit('workbench:logout');
                };
                $timeout(function () {
                    $('[data-toggle="popover"]').popover();
                });
                // scope.closeTreeContextMenu = function () {
                //     document.getElementById("contextMenu").style.display = 'none';
                // };
            }
        };
    }]);
//# sourceMappingURL=navbar-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/navbar/app/js/plumbing/navbar-directive.js